import { AssetType } from './reusableTypes';

export const isBpfsAsset = (assetType: AssetType) =>
  [AssetType.ETF, AssetType.ETC, AssetType.STOCK].includes(assetType);
